import styled from 'styled-components';
import { MEDIA_QUERIES } from '@student-coin/coinpaper-components';

const variants = {
  small: {
    fontSize: '1rem',
    fontWeight: '600',
    letterSpacing: '0px',
    lineHeight: '1.2rem',
    marginBottom: '0.5rem',
  },
  medium: {
    fontSize: '1.125rem',
    fontWeight: '700',
    letterSpacing: '1px',
    lineHeight: '1.6875rem',
    marginBottom: '1rem',
  },
};

export const Container = styled.div<{ border?: string }>`
  border-top: ${({ theme, border }) => border === 'solid' && `2px solid ${theme.colors.title}`};
`;

export const Divider = styled.div`
  margin: 1rem 0;
  border: ${({ theme }) => `1px dashed ${theme.colors.title}`};

  @media ${MEDIA_QUERIES.tablet} {
    display: none;
  }
`;

export const Articles = styled.div<{ border?: string; grid?: { column: number } }>`
  border-top: ${({ theme, border }) => border === 'dashed' && `1px dashed ${theme.colors.title}`};
  border-bottom: ${({ theme, border }) =>
    border === 'dashed' && `1px dashed ${theme.colors.title}`};
  padding: ${({ border }) => border === 'dashed' && '1rem 0'};
  @media ${MEDIA_QUERIES.tablet} {
    display: ${({ grid }) => (grid ? 'grid' : 'flex')};
    grid-template-columns: ${({ grid }) => grid?.column && `repeat(${grid?.column}, 1fr)`};
    gap: 2.5rem;
    padding: ${({ border }) => border === 'dashed' && '2rem 0'};
  }
`;

export const Header = styled.p<{
  variant?: string;
}>`
  font-size: ${({ variant }) => variants[variant]?.fontSize ?? '1rem'};
  font-weight: ${({ variant }) => variants[variant]?.fontWeight ?? '600'};
  letter-spacing: ${({ variant }) => variants[variant]?.letterSpacing ?? '1.76px'};
  line-height: ${({ variant }) => variants[variant]?.lineHeight ?? '1.6875rem'};
  padding-top: 0.5rem;
  margin-bottom: ${({ variant }) => variants[variant]?.marginBottom ?? '0.5rem'};
`;
